import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";
import { enableMapSet } from "immer";
import rootReducer from "./slices";

// Enable Map and Set support in Immer
enableMapSet();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
        ignoredPaths: [],
      },
    }),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;